import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const WarningBadgeIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
        viewBox='0 0 12 13'
        fill='currentColor'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
        ref={ref}
    >
        <g clipPath='url(#clip0_3058_1229)'>
            <circle cx='6' cy='6.5' r='6' fill='rgba(var(--time-webkit-color-away-indicator-rgb))'/>
            <path d='M6 3.5V6.44094' stroke='#3A3A3A' strokeWidth='1.67' strokeLinecap='round' strokeLinejoin='round'/>
            <circle cx='6' cy='9.5' r='1' fill='#3A3A3A'/>
        </g>
        <defs>
            <clipPath id='clip0_3058_1229'>
                <path d='M0 6.5C0 3.18629 2.68629 0.5 6 0.5C9.31371 0.5 12 3.18629 12 6.5C12 9.81371 9.31371 12.5 6 12.5C2.68629 12.5 0 9.81371 0 6.5Z' fill='white'/>
            </clipPath>
        </defs>
    </svg>
));
